export default "__VITE_ASSET__fd29e564__"